import * as types from "../mutation-type"
import axios from "axios/index";


export default {
  state: {
    logs: {
      info:[]
    },
  },
  mutations: {
    [types.SET_LOGS](state, payload) {
      state.logs.info = payload.info
    },

  },
  actions: {
    getLogs({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "update-log/all"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_LOGS,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
